<!-- =========================================================================================
  File Name: TheCustomizer.vue
  Description: Template Customizer
  Component Name: TheCustomizer
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="theme-customizer" class="hidden">

    <!-- Open Customizer Button -->
    <vs-button
      @click.stop="active=!active"
      color="primary"
      type="filled"
      class="customizer-btn"
      icon-pack="feather"
      icon="icon-list" />

    <!-- Customizer Content -->
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="active"
      class="items-no-padding">
      <div class="h-full">

        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>TASKS</h4>
            <!--            <small>Customize & Preview in Real Time</small>-->
          </div>
          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0" />

        <div class="vx-row my-5 mx-3">
          <div class="vx-col w-full ml-auto">
            <vs-button @click.native="onClickTaskCreate" class="float-right w-full my-4"  size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">ADD TASK</vs-button>
          </div>
        </div>

        <div class="vx-row my-3 mx-3">
          <div class="vx-col w-full">
            <ul class="page-suggestions-list">
               <span v-for="n in 6">
               <li class="page-suggestion flex items-center mb-4">
                 <div class="leading-tight">
                   <p class="font-medium">Hello Task One</p>
                   <span class="text-xs">
                    2020/11/28 09:50AM
                   </span>
                 </div>
                 <div class="ml-auto">
                   <div class="flex">
                     <vx-tooltip text="Edit Task" position="left" class="ml-3">
                        <!--                    <vs-button @click="popupActive=true"-->
                        <vs-button @click.native="onClickTaskEdit" size="small"
                                   radius color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                   </div>
                 </div>
               </li>
               <vs-divider/>
               </span>
            </ul>
            <div class="text-center" style="cursor: pointer">
              show completed tasks
            </div>
          </div>
        </div>
      </div>
    </vs-sidebar>
    <vs-popup class="vs-con-loading__container user-edit-popup"
              :title="popUpTitle"
              :active.sync="popupActive"
              :buttons-hidden="true">
      <vx-card no-shadow>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Task Title</small>
            <vs-input  required name="name" class="w-full required" label=""/>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Assign Staff</small>
            <vs-input  required name="name" class="w-full required" label=""/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Due Date</small>
            <vs-input type="date"  required name="name" class="w-full required" label=""/>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Completion Time</small>
            <vs-input  required name="name" class="w-full required" label=""/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <small class="label">Task Description</small>
            <vs-textarea height="100px"/>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button class="ml-auto mt-2">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
        </div>
      </vx-card>
    </vs-popup>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  data () {
    return {
      active             : false,
      popupActive: false,
      popUpTitle: ''
    }
  },
  watch: {
    layoutType (val) {

      // Reset unsupported options
      if (val === 'horizontal') {
        if (this.themeMode === 'semi-dark') this.themeMode = 'light'
        if (this.navbarType === 'hidden')   this.navbarTypeLocal = 'floating'
        this.$emit('updateNavbarColor', '#fff')
      }
    }
  },
  methods: {
    updatePrimaryColor (color) {
      this.primaryColor = color
      this.$vs.theme({ primary: color })
    },
    onClickTaskEdit () {
      this.popupActive = true
      this.popUpTitle = 'UPDATE TASK'
    },
    onClickTaskCreate () {
      this.popupActive = true
      this.popUpTitle = 'CREATE TASK'

    }
  },
  components: {
    VuePerfectScrollbar
  }
}

</script>


<style lang="scss">
  #theme-customizer {
    .vs-sidebar {
      position: fixed;
      z-index: 52000;
      width: 400px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
  }

  .customizer-btn {
    position: fixed;
    top: 10%;
    right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 50000;

    /*.vs-icon {*/
    /*  animation: spin 1.5s linear infinite;*/
    /*}*/
  }

  .scroll-area--customizer {
    height: calc(100% - 5rem);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>

